module.exports = __webpack_public_path__ + "media/images/icon-keyboard-arrow-left-3fcd2c857675b28bc0aa3c0f5ab2d17f.svg";